import { render, staticRenderFns } from "./CodigoSaveButton.vue?vue&type=template&id=1bd2cc86&"
import script from "./CodigoSaveButton.vue?vue&type=script&lang=ts&"
export * from "./CodigoSaveButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports